import { Popover, Button, Stack, Text } from '@mantine/core';
import type { SlashCommandDef } from './kianPromptCatalog';

export interface KianSlashMenuProps {
  opened: boolean;
  onChange: (open: boolean) => void;
  slashFiltered: SlashCommandDef[];
  onSelect: (def: SlashCommandDef) => void;
  children: React.ReactNode;
}

export function KianSlashMenu({
  opened,
  onChange,
  slashFiltered,
  onSelect,
  children,
}: KianSlashMenuProps) {
  return (
    <Popover
      opened={opened && slashFiltered.length > 0}
      onChange={onChange}
      position="top"
      width={340}
      shadow="md"
      withinPortal
    >
      <Popover.Target>{children}</Popover.Target>
      <Popover.Dropdown p="xs">
        <Stack gap={4}>
          {slashFiltered.map((d) => (
            <Button
              key={d.cmd}
              variant="subtle"
              color="gray"
              size="compact-xs"
              justify="flex-start"
              fullWidth
              onClick={() => onSelect(d)}
            >
              <Text component="span" size="xs" fw={700} mr={6}>
                /{d.cmd}
              </Text>
              <Text component="span" size="xs" c="dimmed">
                {d.label}
              </Text>
            </Button>
          ))}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
